import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Pageable, MeasureUnitFilterSpec, WrapperPageableResponse } from './service-common';

export interface MeasureUnitDTO {
  id: number;
  code: string;
  name: string;
  description?: string;
  symbol?: string;
  effectiveDate?: string;
  expiryDate?: string;
  state?: 'ACTIVE' | 'INACTIVE';
}

export type WrapperPageableResponseMeasureUnitDTO = WrapperPageableResponse<MeasureUnitDTO>;

@Injectable({
  providedIn: 'root'
})
export class MeasureUnitService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  searchMeasureUnits(
    spec: MeasureUnitFilterSpec = {},
    pageable: Pageable = { page: 0, size: 20 }
  ): Observable<WrapperPageableResponseMeasureUnitDTO> {
    let params = new HttpParams();

    Object.entries(spec).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, String(value));
      }
    });

    params = params.append('page', String(pageable.page));
    params = params.append('size', String(pageable.size));

    if (pageable.sort && pageable.sort.length > 0) {
      pageable.sort.forEach(sort => {
        params = params.append('sort', sort);
      });
    }

    return this.http.get<WrapperPageableResponseMeasureUnitDTO>(
      `${this.apiUrl}/measure-units`,
      { params }
    );
  }

  listMeasureUnits(
    spec: MeasureUnitFilterSpec = {},
    pageable: Pageable = { page: 0, size: 20 }
  ): Observable<WrapperPageableResponseMeasureUnitDTO> {
    let params = new HttpParams();

    Object.entries(spec).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, String(value));
      }
    });

    params = params.append('page', String(pageable.page));
    params = params.append('size', String(pageable.size));

    if (pageable.sort && pageable.sort.length > 0) {
      pageable.sort.forEach(sort => {
        params = params.append('sort', sort);
      });
    }

    return this.http.get<WrapperPageableResponseMeasureUnitDTO>(`${this.apiUrl}/measure-units/list`,{ params });
  }
}
